export enum Method {
  POST = "POST",
  GET = "GET",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum Screen {
  PENDING = "pending",
  INFORMATION = "information",
  SOURCE_SELECTION = "source-selection",
  DATA_SELECTION = "data-selection",
  CREDENTIALS = "credentials",
  PROOF_GENERATION = "proof-generation",
  PROOF_COMPLETION = "proof-completion",
  ERROR = "error",
  OAUTH = "oauth",
  TIMEOUT = "timeout",
  USER_NETWORK = "user-network",
}
